/**
 * Color palette used within the app. Do not repeat colors and keep names
 * simple and intuitive. If you are not certain about the name, please ask
 * before adding.
 */
export default {
  primary: '#3A2E9E',
  primaryText: '#fff',
  secondary: '#FFCAAA',
  secondaryText: '#141027',
  background: '#FDFBF7',
  /**
   * @deprecated
   */
  primaryPurple: '#4D439A',
  /**
   * @deprecated
   */
  secondaryBlack: '#160f2A',
  /**
   * @deprecated
   */
  secondarySand: '#FFD8AB',
  /**
   * @deprecated
   */
  secondaryCreme: '#FAF6F5',
  headerBackground: '#5E51AC',
  profileMenuBackground: '#8C538A',
  primaryPurpleLight: '#E6E3FE',
  darkText: '#000',
  lightText: '#FFF',
  mediumText: '#4D439A',
  link: '#FFF',
  divider: '#E4E4E4',
  formLabel: '#4D4D4D',
  formInputBorder: '#ccc',
  formInputBorderHighlight: '#CCC',
  checked: '#FF5286',
  error: '#EC0202',
  errorCaption: '#EC0202',
  listItemBorder: '#B7B0F3',
  switchTrackLightColor: '#8E81ED',
  switchTrackDarkColor: '#4D439A',
  switchActiveThumbColor: '#E86237',
  dataTrackerAreaGraphColor: '#1C9C7D', // old #E7FFDC
  dataTrackerLineGraphColorLabel: '#E69E6C',
  dataTrackerGuideLineBGTextColor: '#FAF6F5',
  dataTrackerTickDisabled: '#DDDDDD',
  gaugeChartTextColor: '#4F639F',
  dataTrackerGuideLineColor: '#1C9C7D',
  dataTrackerAlternateGuideLineColor: '#E7FFDC',
  dataTrackerGuideTextColor: '#4D439A',
  compareChartPositionColor: '#FF5286',
  compareChartAreaColor: '#E5D3CD',
  compareChartGuideLineColor: '#818181',
  xAxisChartGuideColor: '#EFF2F3',
  xAxisChartColor: '#FAF6F5', //old #4D63A0
  seeAllStudiesTextColor: '#4D439A',
  featuredAlertCardColor: '#E86237',
  featuredInfoCardColor: '#FFD8AB',
  featuredNewCardColor: '#4D439A',
  progressBackgroundColor: '#E86237',
  sleepStudyReminderBackgroundColor: '#E86237',
  newsCardColor: '#E86237',
  pausedBackgroundColor: '#878787',
  recruitingBackgroundColor: '#E69E6C',
  secondaryTextColor: '#4D439A',
  success: '#217e0e',
  warning: '#aa901e',
  info: '#125ec2',
  successBackground: '#cdffc3',
  warningBackground: '#fff4c3',
  errorBackground: '#ffd0dd',
  infoBackground: '#cee2fc',
  chloeBlack: '#160F2A',
  compareChartStrokeSolid: '#27475C',
  chloeOrange: '#E86237',
  placeholderColor: '#BBB',
  chloeSand: '#FFD8AB',
  chloeCamel: '#E69E6C',
  chloePink: '#FF80CE',

  // Checkbox Colors
  checkboxTouched: '#B7B0F3',
  checkbox: '#E2E5EA',

  // Button Colors
  buttonInverseBackground: '#fff',
  buttonDisabled: '#88868f',
  buttonDisabledText: '#FFFFFF',
  buttonOutlineDisabled: '#B3B3B3',

  // Study Overview Header
  studyScreenStatusCircleBorder: '#cfc9f6',
  studyScreenStatusCircleProgress: '#F09D80',

  // Gradient Progress Bar
  gradientProgressBarTrack: '#FFF6F0',
  gradientProgressBarProgress: '#E69E6C',
  gradientProgressBarProgressLight: '#FFD8AB',
  gradientProgressBarProgressDark: '#E86237'
};
